<template>
  <div class="atras" @click="atras">
    <img src="@/assets/img/1x/Arrow-Left.png" alt="volver" />
    <p>Volver</p>
  </div>
</template>

<script>
export default {
  name: "ArrowLeft",
  methods: {
    atras() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
div.atras {
  max-width: 150px;
  cursor: pointer;
}

div.atras * {
  display: inline-block;
  vertical-align: middle;
}

img {
  width: 20px;
  height: auto;
  display: inline-block;
  margin-right: 0.4em;
}

p {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  color: #1464a5;
}
</style>
